const SHOPIFY_SUFFIX = '.myshopify.com';

export function normalizeShopifyUrl(raw: string): string {
  const trimmed = raw.trim().replace(/^https?:\/\//, '');
  if (!trimmed) return '';
  return trimmed.includes('.') ? trimmed : `${trimmed}${SHOPIFY_SUFFIX}`;
}
